import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { fromArrToObj } from "../Tags";
import { deepClone } from "../../../deepClone";

type Props = {
  selectedStrategy: any;
  tags: any;
};

const Editor = forwardRef(({ selectedStrategy, tags }: Props, ref) => {
  const prepareTagData = useCallback(
    (tagsData: any) => {
      if (Array.isArray(tagsData)) {
        let tempObj = fromArrToObj(tagsData, tags);
        return tempObj;
      } else if (typeof tagsData === "object" && tagsData !== null) {
        return tagsData;
      } else {
        let tempObj: any = {};
        tags.forEach((element) => {
          tempObj[element.id] = null;
        });
        return tempObj;
      }
    },
    [tags],
  );
  const [objState, setObjState] = useState(() => {
    if (selectedStrategy?.tags?.data) {
      return prepareTagData(selectedStrategy.tags.data);
    }

    return prepareTagData(null);
  });

  useEffect(() => {
    console.log("selectedStrategy", selectedStrategy);
  }, [selectedStrategy]);

  useEffect(() => {
    console.log("objState", objState);
  }, [objState]);

  const tagHandler = (obj: {
    checked: boolean;
    value: string;
    filterType: "single" | "multiple";
    groupID: string;
  }) => {
    switch (obj.filterType) {
      case "multiple":
        if (obj.checked === true) {
          //-------
          setObjState((prev) => {
            let _prev = deepClone(prev);
            if (_prev[obj.groupID]) {
              _prev[obj.groupID] = [..._prev[obj.groupID], obj.value];
            } else {
              _prev[obj.groupID] = [obj.value];
            }
            return _prev;
          });
          //-------
        } else if (obj.checked === false) {
          //---
          setObjState((prev) => {
            let _prev = deepClone(prev);
            _prev[obj.groupID] = _prev[obj.groupID].filter(
              (tag) => tag !== obj.value,
            );
            return _prev;
          });
          //---
        }
        break;
      case "single":
        //---
        setObjState((prev) => {
          let _prev = deepClone(prev);
          _prev[obj.groupID] = obj.value;
          return _prev;
        });
        //---
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    getObjFilters: () => deepClone(objState),
  }));

  return (
    <Box overflow={"auto"}>
      <Box display={"flex"} flexDirection={"column"} gap={2} p={2}>
        {tags.map((group, index) => {
          if (group.type === "single") {
            return (
              <Single
                key={index}
                value={objState[group.id]}
                groupName={group.name}
                filters={group.filters}
                onChange={(event) => {
                  tagHandler({
                    checked: event.target.checked,
                    value: event.target.value,
                    filterType: group.type,
                    groupID: group.id,
                  });
                }}
              />
            );
          }
          if (group.type === "multiple") {
            return (
              <Multiple
                key={index}
                value={objState[group.id]}
                groupName={group.name}
                filters={group.filters}
                onChange={(event) => {
                  tagHandler({
                    checked: event.target.checked,
                    value: event.target.value,
                    filterType: group.type,
                    groupID: group.id,
                  });
                }}
              />
            );
          }
          return null;
        })}
      </Box>
    </Box>
  );
});

export default Editor;
type SingleType = {
  groupName: string;
  filters: any[];
  value: any;
  onChange: any;
};
const Single = ({ groupName, filters, value, onChange }: SingleType) => {
  return (
    <Card sx={{ boxShadow: 3 }}>
      <CardContent sx={{ p: 2, pb: "16px !important" }}>
        <Typography>
          <strong>{groupName}</strong>
        </Typography>
        <RadioGroup onChange={onChange} color="secondary" value={value}>
          {filters.map((filter, index) => (
            <FormControlLabel
              key={index}
              value={filter.id}
              control={<Radio />}
              label={filter.name}
            />
          ))}
        </RadioGroup>
      </CardContent>
    </Card>
  );
};

type MultipleType = {
  groupName: string;
  filters: any[];
  value: string[] | null;
  onChange: any;
};
const Multiple = ({ groupName, filters, value, onChange }: MultipleType) => {
  return (
    <Card sx={{ boxShadow: 3 }}>
      <CardContent sx={{ p: 2, pb: "16px !important" }}>
        <Typography>
          <strong>{groupName}</strong>
        </Typography>
        <FormGroup onChange={onChange} color="secondary">
          {filters.map((filter, index) => (
            <FormControlLabel
              key={index}
              value={filter.id}
              name={filter.id}
              control={
                <Checkbox checked={value?.includes(filter.id) ?? false} />
              }
              label={filter.name}
            />
          ))}
        </FormGroup>
      </CardContent>
    </Card>
  );
};
